import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { withRouter } from 'library/util/core-router';
import withConfig from 'util/hoc/with-config';

class PathwaysEditBar extends React.Component {
  handleRegenerate = async () => {
    if (this.props.pathway && confirm(`Are you sure? Any unsaved data won't be included in the pathway`)) {
      this.props.history.replace('/pathways');
      this.props.refreshPathway();
    }
  }

  render() {
    const {
      pathway,
      children,
      configuration
    } = this.props;

    return (
      <div className="pathways-edit-bar">
        {
          resolve(configuration, 'apps/pathways/configuration/edit_bar/label', true)
            ? (
              <p>Editing Info</p>
            )
            : null
        }
        { children }
        {
          pathway
            ? (
              <button onClick={this.handleRegenerate}>Regenerate Pathway</button>
            )
            : null
        }
      </div>
    );
  }
}

export default withRouter(withConfig(PathwaysEditBar));
